import { defineMessages } from 'react-intl';

export default defineMessages({
  fullscreen: {
    id: 'cboard.components.FullScreenButton.fullscreen',
    defaultMessage: 'Full screen'
  },
  exitFullscreen: {
    id: 'cboard.components.FullScreenButton.exitFullscreen',
    defaultMessage: 'Exit full screen'
  }
});
